import { Component, Inject, HostBinding } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Product, Negotiation } from '@vestiaire/api-sdk-angular';

export interface MmaoPopinComponentData {
  product: Product;
  negotiation: Negotiation | null;
  buyerId: string;
  commentId: string | null;
}

@Component({
  selector: 'vc-mmao-popin',
  templateUrl: './mmao-popin.component.html',
  styleUrls: ['./mmao-popin.component.scss']
})
export class MmaoPopinComponent {
  @HostBinding('class.hasLoader')
  submitting = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: MmaoPopinComponentData) {}

  isSubmitting($event: boolean) {
    this.submitting = $event;
  }
}
